import DistrictOverridePanel from "./DistrictOverridePanel";
import RestrictionPanel from "./RestrictionPanel";
import AccessControlActions from "./AccessControlActions";

export default function ActiveRestrictionDetails({
  scope,
  restriction,
  districtRestriction,
  isLockedByDistrict,
  isRevoking,
  onEdit,
  onRevoke,
  onCreateSchoolRule,
}) {
  const isAdmin = scope === "school";

  if (!restriction && !districtRestriction) return null;

  return (
    <div className="flex flex-col gap-2.5">
      {isAdmin && districtRestriction && (
        <DistrictOverridePanel restriction={districtRestriction} />
      )}
      {restriction && (
        <RestrictionPanel
          restriction={restriction}
          label="App Temporarily turned OFF for Students During the Time Period Below:"
        />
      )}
      <AccessControlActions
        isAdmin={isAdmin}
        restriction={restriction}
        isLockedByDistrict={isLockedByDistrict}
        isRevoking={isRevoking}
        onEdit={onEdit}
        onRevoke={onRevoke}
        onCreateSchoolRule={onCreateSchoolRule}
      />
    </div>
  );
}
